export default function waitForTransitionEnd(element, callback, fallbackTimeout = null) {
    const eventListener = (e) => {
        if (!e || e.target === element) {
            element.removeEventListener("transitionend", eventListener);
            element.removeEventListener("webkitTransitionEnd", eventListener);
            callback();
            callback = () => { };
        }
    };
    element.addEventListener("transitionend", eventListener);
    element.addEventListener("webkitTransitionEnd", eventListener);
    if (fallbackTimeout) {
        setTimeout(eventListener, fallbackTimeout);
    }
}
